/**
 * RC 1.61 S2.B.1 — Institutional disclaimer (React/in-app twin).
 *
 * Single source of canonical wording lives here as a constant so the
 * line stays identical across in-app surfaces (Account Plan, Employer
 * Billing, Pricing-equivalent surfaces in-app). The marketing-site
 * twin is `marketing/src/components/Disclaimer.astro`, sourcing the
 * same canonical text from `marketing/src/lib/site.ts`.
 *
 * Editing this line is a positioning change — review with the
 * operator before touching it.
 *
 * Variants:
 *   inline — italic muted single line (default).
 *   block  — bordered tile with caps-gold "Operating posture" label;
 *            suitable for billing summaries / plan pickers.
 *
 * Usage:
 *   <Disclaimer />
 *   <Disclaimer variant="block" testId="employer-billing-disclaimer" />
 */
import React from 'react';

export const DOCTRINE_DISCLAIMER =
  'NDORFlow does not auto-apply, auto-tailor, or auto-decide. '
  + 'Every paid action requires explicit user intent.';

export default function Disclaimer({
  variant = 'inline',
  testId = 'doctrine-disclaimer',
  className = '',
}) {
  if (variant === 'block') {
    return (
      <aside
        className={
          'rounded-md border border-ndor-edge bg-ndor-surface-alt/40 px-5 py-4 '
          + className
        }
        data-testid={testId}
        data-doctrine="institutional-disclaimer"
      >
        <p className="font-mono-ui text-[11px] uppercase tracking-[0.14em] text-ndor-gold">
          Operating posture
        </p>
        <p className="mt-2 text-sm leading-relaxed text-ndor-ink-secondary">
          {DOCTRINE_DISCLAIMER}
        </p>
      </aside>
    );
  }
  return (
    <p
      className={'text-sm leading-relaxed text-ndor-ink-muted italic ' + className}
      data-testid={testId}
      data-doctrine="institutional-disclaimer"
    >
      {DOCTRINE_DISCLAIMER}
    </p>
  );
}
